// extracted by mini-css-extract-plugin
module.exports = {"overlayContainer":"NoInternetConnection_overlayContainer__3N0NA","logo":"NoInternetConnection_logo__3CAZV","text":"NoInternetConnection_text__3chWq"};